module.exports = __webpack_public_path__ + "static/media/caretDown2.16e380d0.svg";